import { useRoutes } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import UserStatusBlockingScreen from '@/components/UserStatusBlockingScreen';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { UserStatus } from '@/hooks/useUserQuery';
import SecretFeatureFlagPage from '@/pages/SecretFeatureFlagPage';

import { getSharedRoutes } from './getSharedRoutes/getSharedRoutes';

import { getCrmRoutes } from './getCrmRoutes';
import { ProtectedRoute } from './ProtectedRoute';
import { RoutePath } from './RoutePath';

const RouteConfig = () => {
  const { data: currentUser, isLoading } = useCurrentUser();

  if (isLoading || !currentUser) {
    return null;
  }

  if (
    currentUser.status === UserStatus.PENDING ||
    currentUser.status === UserStatus.DEACTIVATED
  ) {
    return <UserStatusBlockingScreen status={currentUser.status} />;
  }

  const routes = [
    ...getSharedRoutes(currentUser),
    ...getCrmRoutes(currentUser),
    ...(currentUser.email.endsWith('@exacare.com')
      ? [
          {
            path: RoutePath.SecretFeatureFlagService,
            element: (
              <ProtectedRoute role="L0" component={SecretFeatureFlagPage} />
            )
          }
        ]
      : [])
  ];

  return useRoutes(routes);
};

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(RouteConfig);
export { SentryRoutes as RouteConfig };
